/**
 * Shared constants for the CustomerTryOnStudio module.
 * Centralised here so every sub-component/hook imports from one place.
 */

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const TRYON_STUDIO_LOGO =
  'https://v1-garments.s3.ap-south-1.amazonaws.com/nanokart_ai/20260128073408.webp';

export const MAX_IMAGE_SIZE_MB = 20;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

export const ITEMS_PER_PAGE = 7;

/** Moment scene types shown in the Moments panel */
export const MOMENTS = [
  { id: 'creative_workday', label: 'Workday',   icon: '💼' },
  { id: 'unwind',           label: 'Unwind',     icon: '🛋️' },
  { id: 'after_hours',      label: 'After Hours', icon: '🌙' },
  { id: 'escape',           label: 'The Escape', icon: '🌴' },
  { id: 'gentle_celebration', label: 'Celebrate', icon: '🎉' },
];

/** Photo tips shown in the ProTips modal */
export const PRO_TIPS = [
  { text: 'Just you: Single person photos work best', icon: '👤' },
  { text: 'Head to toe: Full body visible, head to feet', icon: '📏' },
  { text: 'Well-fitted clothes: Close-fitting outfits help AI understand your shape', icon: '👕' },
  { text: 'Good lighting: Natural daylight, avoid harsh shadows', icon: '☀️' },
  { text: 'Face the camera: Stand comfortably, face forward', icon: '📷' },
  { text: 'Clear background: Remove distractions from frame', icon: '🖼️' },
];

/** Human-readable label map for moment types used in the session-ended screen */
export const MOMENT_LABELS = {
  sunset_glow:       'Sunset Glow',
  studio_spotlight:  'Studio Spotlight',
  golden_hour:       'Golden Hour',
  urban_chic:        'Urban Chic',
  minimalist:        'Minimalist',
  magazine_cover:    'Magazine Cover',
  creative_workday:  'Workday',
  unwind:            'Unwind',
  after_hours:       'After Hours',
  escape:            'The Escape',
  gentle_celebration:'Celebrate',
};
